module.exports = __webpack_public_path__ + "front/img/p10.51f62866.png";